const endpoints = {
  auth: {
    login: "/login",
    logout: "/logout",
    resetpassword: "/forgot-password/reset",
    sendotp: "/forgot-password/send-otp",
    verifyotp: "/forgot-password/verify-otp",
  },
  admin: {
    userList: "/admin/user-list",
    createUser: "/admin/user-list",
    updateUser: "/admin/user-detail/{user_id}",
    deleteUser: "/admin/user-detail/{user_id}",
    sendlink: "/user/user-chat-link-send/{user_id}",
    userDetail: "/admin/user-detail/{user_id}",
    sendMailBroker: "/admin/send-email-to-broker",
    downloadPdf: "/admin/user-download/{user_id}",
  },
  user: {
    chatUser: "/user/user-chat/{token}",
  },
};

export default endpoints;
